module.exports = __webpack_public_path__ + "img/user-default.8bdbe1da.svg";